import { SUPPORTED_NETWORKS } from 'src/configs/Connect/Configs.networks';
import { ChainId } from 'src/configs/Connect/Configs.chainId';

export const networks = [SUPPORTED_NETWORKS[ChainId.MAINNET], SUPPORTED_NETWORKS[ChainId.BSC]];

export const ACTION_TYPES = {
    CHOOSE_NETWORK: '[connect] action choose network',
};
